module.exports = __webpack_public_path__ + "img/share-bg-7.73cac6cd.jpg";